export enum RiskAssessmentReportIndicatorStatusEnum {
  RISK_PRESENT = "RISK_PRESENT",
  RISK_ABSENT = "RISK_ABSENT",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}
